export const ALLOWED_BILLED_UPON = [
    'ongoing',
    'oneTimeManual',
    'approval',
    'repeatableManual',
    'oneTimeDelivery',
    'oneTimeInStages',
    'onDemand',
    'inStagesManual',
    'inStagesPartlyAutomatic',
    'inStagesAutomatic'
];
export const SERVICE_QUANTIFIERS = [
    'any',
    'all',
    'none'
];
export const CREDIT_CARD_FEES_PAID_BY = [
    'client',
    'service_provider'
];
